import { GlobalFormats } from '../../classes/main/globalFormatClass';
import { getLanguageObj, settings } from '../../helpers/UtilsHelper';

const { html } = settings;

const currentMethod = 'TableIndex';

export default function TableIndex({
    tableId = '',
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    return (
        <div className='row'>
            <div className='col-12'>
                <div className={html?.dataTables?.formats?.tableResponsiveSm}>
                    <table id={tableId} className={html?.dataTables?.formats?.tableHoverW100Border0} style={{ borderRadius: '5px' }} />
                </div>
            </div>
        </div>
    );
}